import { render, staticRenderFns } from "./EditSoftSaleStockItem.vue?vue&type=template&id=70d8a16a"
import script from "./EditSoftSaleStockItem.vue?vue&type=script&lang=js"
export * from "./EditSoftSaleStockItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EditSoftSaleStockItem.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70d8a16a')) {
      api.createRecord('70d8a16a', component.options)
    } else {
      api.reload('70d8a16a', component.options)
    }
    module.hot.accept("./EditSoftSaleStockItem.vue?vue&type=template&id=70d8a16a", function () {
      api.rerender('70d8a16a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/EditSoftSaleStockItem.vue"
export default component.exports